import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import icon01 from "../../assets/img/icon/choose_icon01.svg";
import icon02 from "../../assets/img/icon/choose_icon02.svg";
import icon03 from "../../assets/img/icon/choose_icon03.svg";
import icon04 from "../../assets/img/icon/choose_icon04.svg";
import WhyChooseUsItem from "./WhyChooseUsItem";

const WhyChooseUs = () => {
  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const slider_items = [
    {
      src: icon01,
      alt: "",
      link: "/",
      title: "Innovative Blockchain Security",
      description: "EVOX Casino uses the most advanced blockchain technology to ensure every game and transaction is secure, transparent, and tamper-proof.",
    },
    {
      src: icon02,
      alt: "",
      link: "/",
      title: "Complete Anonymity",
      description: "Play poker without compromising your privacy. Our platform allows you to engage anonymously, using cryptocurrencies for all transactions.",
    },
    {
      src: icon03,
      alt: "",
      link: "/",
      title: <>Crypto-Exclusive Payments</>,
      description: "Enjoy seamless, fast, and secure payments with cryptocurrencies, bypassing traditional banking hurdles and allowing global access.",
    },
    {
      src: icon04,
      alt: "",
      link: "/",
      title: "Poker-Focused Excellence",
      description: "Unlike other casinos, we specialize in poker. This means a refined, premium experience for true poker enthusiasts.",
    },
    {
      src: icon01,
      alt: "",
      link: "/",
      title: "Community and Social Features",
      description: "EVOX Casino goes beyond gaming. Connect with other players, send friend requests, chat privately, and create custom poker rooms in a decentralized environment.",
    },
    {
      src: icon04,
      alt: "",
      link: "/",
      title: "Early Investor Advantage",
      description: "By joining EVOX Casino now, you're investing in the future of online poker, with our EVOX tokens offering growth potential as the platform expands.",
    },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / slider_items.length;

  return (
    <section className="choose-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-50">
              <span className="sub-title">Why invest in us </span>
              <h2 className="title">
                Why buy our <span>ECX</span> Token
              </h2>
            </div>
          </div>
        </div>

        <div className="row choose-active">
          <SlickSlider settings={slickSettings}>
            {slider_items.map((item, index) => (
              <div key={index} className="col-lg-3">
                <WhyChooseUsItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div className="slide-progressbar">
          <div
            style={{
              // width: `${count * toMultiply}%`,
              backgroundSize: `${count * toMultiply}% 100%`,
            }}
            className="slide-filler"
          />
        </div>

        {/* <div
          className="slide-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <span className="slider__label sr-only"></span>
        </div> */}
      </div>
    </section>
  );
};

export default WhyChooseUs;
